import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterControls = ({ filters, onFilterChange, onResetFilters, services, servicesLoading, servicesError }) => {
  const statusOptions = [
    { value: 'all', label: '전체 상태' },
    { value: '주문 접수', label: '주문 접수' },
    { value: '주문완료', label: '주문완료' },
    { value: '픽업 예정', label: '픽업 예정' },
    { value: '세탁 중', label: '세탁 중' },
    { value: '배송 예정', label: '배송 예정' },
    { value: '완료', label: '완료' }
  ];

  const serviceTypeOptions = [
    { value: 'all', label: servicesLoading ? '서비스 불러오는 중...' : '전체 서비스' },
    ...(services || []).map((s) => ({
      value: s?.name,
      label: s?.name,
    })),
  ];

  return (
    <div className="space-y-4">
      {servicesError && (
        <div className="rounded-lg bg-error/10 p-4">
          <p className="text-sm font-medium text-error">{servicesError}</p>
        </div>
      )}

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        <Select
          label="상태"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          label="서비스 유형"
          options={serviceTypeOptions}
          value={filters?.serviceType}
          onChange={(value) => onFilterChange('serviceType', value)}
        />

        <Input
          label="시작 날짜"
          type="date"
          value={filters?.startDate}
          onChange={(e) => onFilterChange('startDate', e?.target?.value)}
          className="bg-muted"
        />

        <Input
          label="종료 날짜"
          type="date"
          value={filters?.endDate}
          onChange={(e) => onFilterChange('endDate', e?.target?.value)}
          className="bg-muted"
        />
      </div>
      <div className="flex flex-col space-y-3 sm:flex-row sm:items-end sm:space-x-3 sm:space-y-0">
        <div className="flex-1">
          <Input
            label="고객 검색"
            type="search"
            placeholder="고객명 또는 연락처로 검색"
            value={filters?.searchQuery}
            onChange={(e) => onFilterChange('searchQuery', e?.target?.value)}
            className="bg-muted"
          />
        </div>
        <Button
          variant="outline"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onResetFilters}
        >
          필터 초기화
        </Button>
      </div>
    </div>
  );
};

export default FilterControls;